import React from 'react';
import { Shield, Star, MapPin, Handshake, PenTool, Wrench } from 'lucide-react';
const CARDS = [{
  title: 'Local Residential Glass Experts',
  copy: 'Serving Southeast Michigan homeowners with window glass, door glass, showers, mirrors, screens and custom glass projects since 2000.',
  Icon: MapPin
}, {
  title: 'Free In-Home Estimates',
  copy: 'Get a no-obligation estimate and clear next steps before work begins.',
  Icon: Star
}, {
  title: 'Glass-Only Guidance',
  copy: 'Learn whether your project needs new glass, insulated glass replacement, seal repair or full window replacement.',
  Icon: Handshake
}, {
  title: 'No High-Pressure Sales',
  copy: 'The team helps you understand repair, replacement and glass-only options without pressure.',
  Icon: Shield
}, {
  title: 'Custom Fabrication',
  copy: 'Get glass measured, ordered, fabricated or prepared for your window, door, shower, mirror, table top or custom project.',
  Icon: PenTool
}, {
  title: 'Warranty-Backed Work',
  copy: 'Professional residential glass repair, replacement and installation backed by warranty protection.',
  Icon: Wrench
}];
export function WhyChooseUs() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 text-white" data-id="element-1454">
      <div className="max-w-7xl mx-auto" data-id="element-1455">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1456">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight" data-id="element-1457">
            Why Homeowners Choose Kosin's Glass
          </h2>
        </div>
        <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1458">
          {CARDS.map(({
          title,
          copy,
          Icon
        }, idx) => <li key={idx} className="bg-navy-800 rounded-2xl p-8 border border-navy-700 anim-on-scroll" data-id="element-1459">
              <div className="w-12 h-12 rounded-full bg-navy-900 border border-navy-600 flex items-center justify-center mb-6" data-id="element-1460">
                <Icon className="w-6 h-6 text-brandBlue-600" aria-hidden="true" data-id="element-1461" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-white" data-id="element-1462">{title}</h3>
              <p className="text-slate-300 leading-relaxed" data-id="element-1463">{copy}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}